/** @format */

import React from "react";
import { Container, Typography, Link, styled } from "@mui/material";
import { Box } from "./MuiCompat";

const StyledFooter = styled(Box)({
  position: "relative",
  zIndex: 1,
  color: "#FFFFFF",
  borderTop: "1px solid rgba(255, 255, 255, 0.06)",
});

const ContentContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(8),
}));

const NavLinks = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: theme.spacing(3),
  marginBottom: theme.spacing(6),
}));

const StyledLink = styled(Link)({
  color: "#9C9C9D",
  fontFamily:
    "'Inter', ui-sans-serif, system-ui, -apple-system, sans-serif",
  fontSize: "14px",
  fontWeight: 400,
  letterSpacing: "0.01em",
  textDecoration: "none",
  transition: "color 200ms ease",
  "&:hover": {
    color: "#FFFFFF",
    textDecoration: "none",
  },
});

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <StyledFooter component="footer">
      <ContentContainer maxWidth="lg">
        <NavLinks>
          <StyledLink href="/">Home</StyledLink>
          <StyledLink href="/about">About Us</StyledLink>
          <StyledLink href="/contact">Contact</StyledLink>
          <StyledLink href="/privacy-policy">Privacy Policy</StyledLink>
          <StyledLink href="/terms-of-service">Terms of Service</StyledLink>
        </NavLinks>
        <Typography
          align="center"
          sx={{
            fontFamily:
              "'Inter', ui-sans-serif, system-ui, -apple-system, sans-serif",
            fontSize: "12px",
            fontWeight: 400,
            letterSpacing: "0.04em",
            color: "#6A6B6C",
          }}
        >
          © {currentYear} EON.HEALTH. All rights reserved.
        </Typography>
      </ContentContainer>
    </StyledFooter>
  );
};

export default Footer;
